import { Bath, Building2, Calendar, Flame, Home, Layers, Ruler, Sofa } from "lucide-react";

// Icon mapping for quickInfos
const QUICK_INFO_ICONS = {
  room_count: Sofa,
  gross_square: Ruler,
  net_square: Ruler,
  floor_number: Layers,
  building_age: Calendar,
  bathroom_count: Bath,
  heating_type: Flame,
  balcony: Home,
};

/**
 * Quick info grid displaying property details
 */
export function DetailQuickInfosGrid({ quickInfos, isDark, maxItems = 6 }) {
  if (!quickInfos || quickInfos.length === 0) return null;

  return (
    <div className={`rounded-xl border p-3 ${isDark ? "border-white/10 bg-white/5" : "border-gray-100 bg-gray-50"}`}>
      <div className="grid grid-cols-2 gap-2">
        {quickInfos.slice(0, maxItems).map((info, idx) => {
          const IconComponent = QUICK_INFO_ICONS[info.key] || Building2;
          return (
            <div key={info.key || idx} className="flex items-center gap-2">
              <IconComponent
                className={`h-3.5 w-3.5 flex-shrink-0 ${isDark ? "text-white/40" : "text-gray-400"}`}
                strokeWidth={1.5}
              />
              <div className="min-w-0 flex-1">
                <div className={`text-[10px] uppercase tracking-wide ${isDark ? "text-white/40" : "text-gray-400"}`}>
                  {info.name}
                </div>
                <div className={`text-xs font-medium truncate ${isDark ? "text-white/80" : "text-gray-700"}`}>
                  {info.value}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DetailQuickInfosGrid;
